export const SIGN_UP = 'SIGN_UP'
export const SIGN_IN = 'SIGN_IN'
export const SIGN_OUT = 'SIGN_OUT'
export const AUTO_SIGN_IN = 'AUTO_SIGN_IN'

export const FETCH_CHATS = 'FETCH_CHATS'
export const FETCH_CHAT = 'FETCH_CHAT'
export const CREATE_CHAT = 'CREATE_CHAT'
export const DELETE_CHAT = 'DELETE_CHAT'
export const LEAVE_GROUP = 'LEAVE_GROUP'
export const SEND_MESSAGE = 'SEND_MESSAGE'
export const RECEIVE_MESSAGE = 'RECEIVE_MESSAGE'
